module.exports = __webpack_public_path__ + "50b6ffec95df5c0141c9f5f29422c57a.png";